"use client";
import { jsxs as A, Fragment as D, jsx as d } from "react/jsx-runtime";
import { createColorScheme as E, createCSSVariables as H } from "@inkeep/cxkit-theme";
import { ColorModeProvider as N } from "@inkeep/cxkit-color-mode";
import { useInkeepConfig as P } from "./config-provider.js";
import { merge as R } from "merge-anything";
import { useCustomStyles as q } from "../atoms/custom-styles.js";
import { useState as B, useRef as L, useEffect as O } from "react";
const Z = ({ children: u }) => {
  const { baseSettings: m } = P(), { theme: r, primaryBrandColor: f, shadowHost: g, rootElement: b, colorMode: h } = m, { primaryColors: C, varsClassName: y } = r, { fontFamily: p, fontSize: M, zIndex: S } = r, v = E(C, f), k = {
    colors: R(r.colors, v),
    fontFamily: p,
    fontSize: M,
    zIndex: S
  }, x = H(k), { customStyles: I, loaded: V } = q(), { sync: e, forcedColorMode: w, ...F } = h ?? {}, [T, c] = B(), j = L(null);
  return O(() => {
    if (!e?.target) return;
    const o = typeof e.target == "string" ? document.querySelector(e.target) : e.target;
    if (!o) return;
    function i(n, t) {
      return t.reduce(
        (z, l) => ({
          ...z,
          [l]: n.getAttribute(l)
        }),
        {}
      );
    }
    const s = new MutationObserver(() => {
      const n = i(o, e.attributes), t = e.isDarkMode?.(n) ? "dark" : "light";
      e.onChange?.(t), c(t);
    });
    s.observe(o, {
      attributes: !0,
      attributeFilter: e.attributes,
      childList: !1,
      subtree: !1
    }), j.current = s;
    const a = e.isDarkMode?.(i(o, e?.attributes)) ? "dark" : "light";
    return e.onChange?.(a), c(a), () => s.disconnect();
  }, [e]), /* @__PURE__ */ A(D, { children: [
    I,
    V && /* @__PURE__ */ d(
      N,
      {
        forcedColorMode: w ?? T,
        ...F,
        shadowHostId: g?.id,
        rootId: b?.id,
        children: /* @__PURE__ */ d(
          "div",
          {
            className: y,
            style: {
              display: "contents",
              ...x
            },
            children: u
          }
        )
      }
    )
  ] });
};
export {
  Z as ThemeProvider
};
